import * as Yup from 'yup';

export const IndicatorCustomConfigSchema = Yup.object().shape({
  '@type': Yup.string(),
  id: Yup.string()
});
